import { t } from 'i18next';
import { generatePdf } from '../../../PdfExports/PdfExport.utils';
import {
  AccessibilityCheckerStore,
  Issue,
} from '@/stores/AccessibilityCheckerStore/AccessibilityChecker.consts';
import { failSvgIcon, greenCircleSvg, passSvgIcon, redCircleSvg } from '@/assets/images/icons';
import { getAccessibilityScoreDic } from '../AccessibilityScore/AccessibilityScore.consts';

export const getIssuesHtml = (a11yCheckerStore: AccessibilityCheckerStore) => {
  const isAuditPassed = a11yCheckerStore.isAuditPassed();
  if (a11yCheckerStore.issuesFound) {
    const allIssues = Object.values(a11yCheckerStore.issuesFound).flatMap((item: any) =>
      Object.entries(item).flatMap(([category, arr]) =>
        (arr as any[]).flat().map((obj) => ({
          ...obj,
          name: category,
        }))
      )
    );

    let lastTitle = '';
    const mappedIssues = allIssues.map((issue: Issue, i: number) => {
      let title = '';
      if (issue.name && issue.name !== lastTitle) {
        lastTitle = issue.name;
        title = `<h3>${t(`free_tools.accessibility_checker.category.${issue.name}`)}</h3>`;
      }

      const status =
        i === 0
          ? `<span id="auditStatus">
${isAuditPassed ? passSvgIcon : failSvgIcon}
    <span class="auditText">${
      isAuditPassed
        ? t('free_tools.accessibility_checker.audit_passed')
        : t('free_tools.accessibility_checker.audit_failed')
    }</span>
    </span>`
          : ``;

      const topSection = `<div class="row-offset">
    ${title}
    ${status}
    </div>`;

      return `${topSection}
                    <div class="issue-block">
                        <h4 class="md-title">${issue.title}</h4>
                        <hr />
                        <div class="description-block">
                            <span class="md-title">${t(
                              'free_tools.accessibility_checker.description'
                            )}:</span>
                            <p class="description">
                            ${issue.description}</p>
                        </div>
                    </div>
               `;
    });
    return mappedIssues.join('');
  }
  return '';
};

export const getScoreHtml = (a11yCheckerStore: AccessibilityCheckerStore) => {
  const accessibilityScoreDic = getAccessibilityScoreDic(
    a11yCheckerStore.accessibilityScore,
    a11yCheckerStore.getAmountOfIssues()
  );

  return Object.keys(getAccessibilityScoreDic()).flatMap((val) => {
    const scoreDic =
      accessibilityScoreDic[val][a11yCheckerStore.isAuditPassed() ? 'passed' : 'failed'];
    return [
      { selector: `#${val}Score`, value: scoreDic.score },
      { selector: `#${val}Content`, value: scoreDic.content },
    ];
  });
};

export const downloadPdf = (a11yCheckerStore: AccessibilityCheckerStore) => {
  generatePdf(
    [
      ...getScoreHtml(a11yCheckerStore),
      {
        selector: '#a11y-issues',
        value: getIssuesHtml(a11yCheckerStore),
      },
      {
        selector: '.statusIcon',
        value: a11yCheckerStore.isAuditPassed() ? greenCircleSvg : redCircleSvg,
      },
      {
        selector: '#mainTitle',
        value: t('free_tools.accessibility_checker.pdf.a11y_checker_result'),
      },
      {
        selector: '#parametersTitle',
        value: `${t('free_tools.parameters.title')}:`,
      },
      {
        selector: '#statusTitle',
        value: t('free_tools.accessibility_checker.a11y_results.status'),
      },
      {
        selector: '#a11yScoreTitle',
        value: t('free_tools.accessibility_checker.a11y_results.score'),
      },
      {
        selector: '#complianceRiskTitle',
        value: t('free_tools.accessibility_checker.a11y_results.compliance'),
      },
      {
        selector: '#a11yIssuesTitle',
        value: `${t('free_tools.accessibility_checker.pdf.a11y_issues')}:`,
      },
      {
        selector: '#ariaRolesTitle',
        value: t('free_tools.accessibility_checker.category.aria_roles'),
      },
    ],
    '/templates/a11yScannerTemplate.html',
    'Accessibility_Checker_Results'
  );
};

export const processDescriptionText = (description: string) => {
  const regex = /\[([^\]]+)\]\(([^)]+)\)/;
  const match = description.match(regex);
  if (match) {
    const [fullMatch, linkText, linkUrl] = match;
    const prefix = description.slice(0, match.index);
    const suffix = match.index && description.slice(match.index + fullMatch.length);
    return (
      <>
        {prefix}
        {/* TODO: For now don't present links. Need to switch dequeue links with wcag links. */}
        {/* <PinkGradientLink href={linkUrl} text={linkText} /> */}
        {suffix}
      </>
    );
  }
  return description;
};
